/**
 * 考生端是否展示「短信登录」。
 * LoginSetting 为空或 IsMsgCode 非 0 时默认展示；IsMsgCode=0 时隐藏。
 * 机构 137 历史原因不开放短信登录。
 */
export function allowMsgCodeLogin(orgExtModel) {
	if (!orgExtModel) {
		return true;
	}
	if (orgExtModel.OrgID === '137') {
		return false;
	}
	const loginSetting = orgExtModel.LoginSetting;
	const loginSettingEmpty = !loginSetting || !String(loginSetting).trim();
	// LoginSetting 为空时默认全开；接口可能把 null 的 IsMsgCode 序列化成 0，不能据此关闭
	if (loginSettingEmpty) {
		return true;
	}
	if (orgExtModel.IsMsgCode === 0 || orgExtModel.IsMsgCode === '0') {
		return false;
	}
	if (orgExtModel.IsMsgCode === 1 || orgExtModel.IsMsgCode === '1') {
		return true;
	}
	try {
		const o = JSON.parse(loginSetting);
		if (o && (o.IsMsgCode === 0 || o.IsMsgCode === '0')) {
			return false;
		}
	} catch (e) {
		// ignore
	}
	return true;
}
